module.exports = __webpack_public_path__ + "static/images/more1.52bdf23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/more1.png
// module id = gMGb
// module chunks = 1